<template>
    <div class="boddy" ref="boddy">
<!-- <Header2 class="titlehed"></Header2> -->
        <Header :isScrolled="isScrolled"></Header>

        <!-- 测试开始 -->
        <img :src="imageUrlone" alt="" class="imgoneru">
        <div style="height: 7vh;"></div>

        <div class="P01Instructions"
        v-for="instruction in instructions" 
        :key="'instruction-' +instruction.id">
                <div class="title">{{ isEnglish ?instruction.titleen: instruction.title }}</div>
                <div class="videos">
                <video 
                    :src="instruction.videoSrc" 
                    autoplay 
                    muted 
                    loop
                ></video>
                </div>
                <div class="content">{{ isEnglish ?instruction.contenten:instruction.content }}</div>
                <div style="width: 60vw;">
                <div style="margin-top: 10vh; width: 30vw; border-bottom: 1px solid gray;"></div>
            </div>
        </div>

        <div class="TIPS">
            <div class="title">{{ isEnglish ?TIPS.titleen:TIPS.title}}</div>
            <div class="content">{{ isEnglish ?TIPS.contenten: TIPS.content }}</div>
            <div class="Indicate">{{ isEnglish ?TIPS.Indicateen:TIPS.Indicate }}</div>
                <div style="margin-top: 7vh; width: 60vw; border-bottom: 1px solid gray;"></div>
        </div>

        <div class="safenote"  v-for="item in safenotes"  :key="'safenote-'+item.id">
            <div class="title">{{ isEnglish ?item.titleen: item.title }}</div>
            <ul>
                <li v-for="(note, noteIndex) in (isEnglish ? item.notesen : item.notes)" :key="noteIndex">{{ note }}</li>
            </ul>

        </div>


        <div class="imgend">
            <!-- <img src="../../assets/Instructionsend.png" alt=""> -->
            <img :src="imgend" alt="">
        </div>
       
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Header from'@/view/public/heardpc.vue'
   
    import Bottom from "@/view/public/bottompc.vue";
    import { mapActions, mapState } from 'vuex';
    import axios from 'axios';
    import apiUrls from '@/http/http'; // 假设 http.js 在 src/http 目录下
    export default {
        computed: {
            // 从 Vuex 的 state 中获取 isEnglish 数据
            ...mapState(['isEnglish']), // 这里读取 state 中的 isEnglish 状态
              // Vuex 的 actions 映射到 methods
              ...mapActions(['changeLanguage']),
          
             
        },
        components:{
            // Header2,
            Header,
            // Bottom2,
            Bottom
        },
        data() {
            return { 
      
                     instructions: [
                                {   id: 1,
                                    titleen: 'sssss',
                                    title: 'P01海关锁密码设置教程',
                                    videoSrc: require('../../assets/Instructionsvideos1.mp4'),
                                    contenten: 'ddddd处或设置您易于记忆的数字组合。',
                                    content: '说明: 为避免遗忘密码, 请将您设置的密码悉心保存至合适之处或设置您易于记忆的数字组合。',
                                },
                                {
                                    id: 2,
                                    titleen: 'sssss',
                                    title: 'U01海关锁密码设置教程',
                                    videoSrc: require('../../assets/Instructionsvideos1.mp4'),
                                    contenten: 'ddddd处或设置您易于记忆的数字组合。',
                                    content: '说明: 为避免遗忘密码,请将您设置的密码悉心保存至合适之处或设置您易于记忆的数字组合。',
                                },
                                 ],


                                 safenotes: [
                                            {
                                                id: 1,
                                                titleen: "安全暂无须知",
                                                title: "安全须知",
                                                notesen: [
                                                "暂无",
                                                "基于铝镁合暂无到撞击，以免箱体变形。",
                                                "为节省您等暂无同时,让您的旅行箱远离暴力托运致损的风险,建议您将其携带登机。如您仍选择托运,请为您的旅行箱使用保护套。",
                                                "拉杆受力有限,请勿在使用拉杆时提起旅行箱。",
                                                "本旅行箱暂无水功能。请勿让旅行箱长时间淋雨。当旅行箱被水淋湿后，请及时用干毛巾擦干，以免雨水渗入箱内。",
                                                "请勿使用暂无精等擦拭箱体，以暂无变形、变色。",
                                                "旅行箱脏暂无沾稀释后的中性洗涤剂(如洗洁精、洗衣液)擦拭,再用洁净的干布擦净,自然通风晾干即可,切勿暴晒。",
                                                "长时间不使暂无雨天过后可开箱通风。"
                                                ],
                                                notes: [
                                                "勿将旅行箱放置在高处，以免意外坠落时造成人员受伤或者旅行箱及箱内物品损坏。",
                                                "旅行箱非玩具，请勿坐在旅行箱上玩要或者推行玩耍，以免旅行箱意外翻倒或者运动速度过快翻倒，造成使用者受伤。",
                                                "请勿在不平整的地方使用脚轮站立，以免旅行箱翻倒或者滑动造成意外。",
                                                "请勿使用脚轮直接越过台阶等凸起物，避免造成使用者受伤或者旅行箱受损。"
                                                ]
                                            },
                                            {
                                                id: 2,
                                                titleen: "安全暂无须知",
                                                title: "注意事项",
                                                notesen: [
                                                "暂无",
                                                "基于铝镁合暂无到撞击，以免箱体变形。",
                                                "为节省您等暂无同时,让您的旅行箱远离暴力托运致损的风险,建议您将其携带登机。如您仍选择托运,请为您的旅行箱使用保护套。",
                                                "拉杆受力有限,请勿在使用拉杆时提起旅行箱。",
                                                "本旅行箱暂无水功能。请勿让旅行箱长时间淋雨。当旅行箱被水淋湿后，请及时用干毛巾擦干，以免雨水渗入箱内。",
                                                "请勿使用暂无精等擦拭箱体，以暂无变形、变色。",
                                                "旅行箱脏暂无沾稀释后的中性洗涤剂(如洗洁精、洗衣液)擦拭,再用洁净的干布擦净,自然通风晾干即可,切勿暴晒。",
                                                "长时间不使暂无雨天过后可开箱通风。"
                                                ],
                                                notes: [
                                                "使用过程中请注意外箱保护,如有必要请使用箱套。",
                                                "基于铝镁合金材质特性,请避免箱体受到撞击，以免箱体变形。",
                                                "为节省您等待行李的时间,同时,让您的旅行箱远离暴力托运致损的风险,建议您将其携带登机。如您仍选择托运,请为您的旅行箱使用保护套。",
                                                "拉杆受力有限,请勿在使用拉杆时提起旅行箱。",
                                                "本旅行箱不具备完全防水功能。请勿让旅行箱长时间淋雨。当旅行箱被水淋湿后，请及时用干毛巾擦干，以免雨水渗入箱内。",
                                                "请勿使用腐蚀性液体如酒精等擦拭箱体，以免导致箱体或配件变形、变色。",
                                                "旅行箱脏污时,请用湿布沾稀释后的中性洗涤剂(如洗洁精、洗衣液)擦拭,再用洁净的干布擦净,自然通风晾干即可,切勿暴晒。",
                                                "长时间不使用时,请放置于干燥通风处,用箱套进行保护，雨天过后可开箱通风。"
                                                ]
                                            }
                                            ],
                                            TIPS:{
                                                titleen:'TIPS:暂无?',
                                                title:'TIPS:忘记密码无法开箱怎么办?',
                                                contenten:'为保障每一位用户的暂无',
                                                content:'为保障每一位用户的财产及隐私安全,忘记密码无法开箱时,需将行李箱寄送到 PUK]谱祺售后服务中心进行维修,对此为您造成的不便敬请谅解。 (更多详情敬请在工作日联络客服 020-39390239 了解)',
                                                Indicateen:'注:PUKI谱祺使用 暂无',
                                                Indicate:'注:PUKI谱祺使用 Travel Sentry Approved® 旅安®认证锁具的行李,在机场进行托运安检时,安检机构可依法正常打开,检查并重新上锁时不会对 行李箱本身造成损坏。'
                                            },

                imageUrlone: require('../../assets/Instructionsimgmain.png'),
                imageUrltwo: require('../../assets/logotuteng.png'),
                imgend: require('../../assets/Instructionsend.png'),
                isScrolled: false,
                ascription: 'Instructions'  // 可以根据实际需求动态设置
        
            };
        },

        mounted() {
            // 在组件加载时获取视频数据
          this.getVideosByAscription(this.ascription);
            this.fetchData();
     
            this.initObserver(); // 初始化观察器
    window.addEventListener('wheel', this.initObserver, { passive: false });
            // window.addEventListener('wheel', this.handleScroll, { passive: false });
            // this.$refs.boddy.addEventListener('scroll', this.debouncedHandleScroll);

        },
        beforeDestroy() {
            window.removeEventListener('wheel', this.initObserver);
            this.$refs.boddy.removeEventListener('scroll', this.debouncedHandleScroll);
            window.removeEventListener('wheel', this.handleScroll);
        },
        methods: {

             // 发送请求获取视频数据
                getVideosByAscription(ascription) {
                axios.get(`${apiUrls.baseUrl}/website/api/Pukivideos`, {
                    params: {
                    ascription: ascription
                    }
                })
                .then(response => {
                    // 将响应数据赋值给 videos
                    const data = response.data;
                    // 假设后端返回的是一个视频列表，可以通过map映射结构
                    const instructions = data.map(item => ({
                    id: item.id,
                    titleen: item.videostitleen,
                    title: item.videostitle,
                    videoSrc:`${apiUrls.devApi}${item.pukivideos}`, // 你需要拼接成合适的视频路径
                    contenten: item.videosdescriptionen,
                    content: item.videosdescription,
                    }));
                this.instructions = instructions; // 更新 instructions 数据

                })
                .catch(error => {
                    alert('请求失败:', error);
                });
                },


            async fetchData() {
            try {
                // 发起 API 请求
                const response = await axios.get(`${apiUrls.baseUrl}/website/api/Instructions`);
                const data = response.data;
                // console.log(data)
                if (data && data.length > 0) {
                    // 处理 banner 图片
                    this.imageUrlone = `${apiUrls.devApi}${data[0].imageUrlone}`;
                     // 分批赋值
                     this.throttledAssignData(data[0]);
                    
                }
            } catch (error) {
                console.error('获取数据失败:', error);
            }
        },
        throttledAssignData(data) {
            // 定义赋值的节奏
            const steps = [
                () => {  
                    //TIPS赋值
                    // console.log(data)
                // 提取并赋值 TIPS
                const titleMatch = this.extractData(data.tips,data.tipsen); // 使用 this 调用方法
                // console.log("提取到的 TIPS:", titleMatch);
                this.TIPS=titleMatch;
                },
                () => {
                    this.safenotes = this.extractSafeNotes(data.safenotes,data.safenotesen); // 使用 this 调用方法
                    // console.log("提取到的 safenotes:", safenotes);
                },
                () => {
                    this.imgend=`${apiUrls.devApi}${data.imgend}`;
                },
            ];

            let stepIndex = 0;

                      const assignNextStep = () => {
                            if (stepIndex < steps.length) {
                                steps[stepIndex](); // 执行当前赋值步骤
                                stepIndex++;

                                // 使用 setTimeout 控制下一次赋值节奏
                                setTimeout(assignNextStep, 100); // 每次间隔 100ms
                            } else {
                                // alert('所有数据赋值完成');
                            }
                        };

                        assignNextStep(); // 开始逐步赋值
        },

          /**
 * 提取 safenotes，包括中文和英文内容
 * @param {string} htmlCN - 包含中文内容的 HTML 字符串
 * @param {string} htmlEN - 包含英文内容的 HTML 字符串
 * @returns {Array} - 返回一个包含中英文标题和内容的 safenotes 数组
 * 格式如下：
 * [
 *   {
 *     id: 1,                   // 唯一标识符
 *     title: "中文标题",        // 中文标题
 *     notes: ["内容1", "内容2"], // 中文内容列表
 *     titleen: "英文标题",       // 英文标题
 *     notesen: ["内容1", "内容2"] // 英文内容列表
 *   }
 * ]
 */
extractSafeNotes(htmlCN, htmlEN) {
    /**
     * 内部函数：从 HTML 字符串中提取标题和内容
     * @param {string} html - HTML 字符串
     * @returns {Array} - 返回一个包含标题和内容的数组
     */
    const extractNotes = (html) => {
        const safenotes = []; // 存储提取后的 safenotes 数据
        let currentId = 1; // 初始化 ID，用于标识每个 safenote

        // 正则表达式匹配标题和有序列表内容部分
        const sectionRegex = /<p><strong[^>]*>(.*?)<\/strong><\/p>.*?<ol>(.*?)<\/ol>/gs;

        let match;
        // 循环查找所有匹配的标题和内容
        while ((match = sectionRegex.exec(html)) !== null) {
            const title = match[1]?.trim() || ""; // 提取标题，去除空格，默认为空字符串
            const content = match[2]; // 提取有序列表的 HTML 内容

              // 使用正则表达式提取每个列表项的文本内容，直接获取 <li> 标签内的文本，忽略所有子标签
                const notes = [...content.matchAll(/<li[^>]*>(.*?)<\/li>/gs)].map(item => {
                // 移除 <li> 标签内的 HTML 标签，获取纯文本
                const text = item[1].replace(/<[^>]+>/g, '').trim(); // 通过正则去除标签
                return text || ""; // 返回纯文本内容，如果为空则返回空字符串
            });


            // 将提取的标题和内容存入 safenotes 数组
            safenotes.push({
                id: currentId++, // 分配唯一 ID
                title: title,    // 标题
                notes: notes     // 内容数组
            });
        }

        return safenotes; // 返回提取后的 safenotes 数组
    };

    // 调用 extractNotes 函数提取中文内容
    const safenotesCN = extractNotes(htmlCN);
    // console.log(safenotesCN)
    // 调用 extractNotes 函数提取英文内容
    const safenotesEN = extractNotes(htmlEN);

    // 将中文和英文内容合并为统一的数据结构
    const safenotes = safenotesCN.map((item, index) => ({
        id: item.id, // 唯一 ID，与中文内容保持一致
        title: item.title, // 中文标题
        notes: item.notes, // 中文内容列表
        titleen: safenotesEN[index]?.title || "暂无", // 英文标题，若不存在则默认为“暂无”
        notesen: safenotesEN[index]?.notes || ["暂无"] // 英文内容列表，若不存在则默认为 ["暂无"]
    }));
    

    // 返回提取后的 safenotes 数组
    return safenotes;
},





        /**
         * 提取tips
         */
        extractData(tips,tipsen){

                // 获取中文内容
            const tipsContent = parseHTMLContent(tips);
            // 获取英文内容
            const tipsEnContent = parseHTMLContent(tipsen);

            // 返回包含所有字段的对象
            return {
                title: tipsContent.title,            // 中文标题
                titleen: tipsEnContent.title,        // 英文标题
                content: tipsContent.content,        // 中文内容
                contenten: tipsEnContent.content,    // 英文内容
                Indicate: tipsContent.indicate,      // 中文注释
                Indicateen: tipsEnContent.indicate,  // 英文注释
            };



            // 提取内容的通用函数
                function parseHTMLContent(html) {
                    if (typeof html !== "string") {
                        console.error("传入的 HTML 不是字符串");
                    }

                   // 提取标题 <strong> 的内容
                   const titleMatch = html.match(/<strong[^>]*>(.*?)<\/strong>/)?.[1] || "TIPS:暂无?";

                // 提取 <p> 标签中的所有内容
                    const allParagraphs = [...html.matchAll(/<p[^>]*>(.*?)<\/p>/g)].map(match => match[1]);

                // 提取正文内容（第二个段落）
                const contentMatch = allParagraphs[1]?.replace(/<[^>]*>/g, "") || "暂无内容";

                        // 提取注释内容（第三个段落）
                const indicateMatch = allParagraphs[2]?.replace(/<[^>]*>/g, "") || "暂无注释";



                    return {
                        title: titleMatch,
                        content: contentMatch,
                        indicate: indicateMatch,
                    };
                }
               
        },

            initObserver() {
                // console.log(this.isEnglish)
                const options = {
                    root: this.$refs.boddy,
                    rootMargin: '0px',
                    threshold: 0.1 // 10% 进入视口时触发
                };
                const ss=   options.root.scrollTop;
                if(ss!=0){
                    this.isScrolled = true;
                }else{ this.isScrolled=false;}


            },


            handleScroll(event) {
                if (event.deltaY !== 0) {
                    const isMobile = window.innerWidth < 768;
                    if (isMobile) {
                        return; // 如果是手机界面，直接返回，取消滚动效果
                    }
                    const scrollContainer = this.$refs.boddy;
                    if (scrollContainer.scrollTop === 0) {
                        this.scrollCount = 0;
                    }
                     // 获取每个section元素
                     const sectionElements = this.$refs.sectionElement;
                     // 计算当前应该滚动到哪个section
                     const direction = event.deltaY > 0 ? 1 : -1; // 根据滚动方向确定是向上还是向下
                     // 计算滚动后的位置
                    this.scrollCount += direction;
                    // 防止越界
                    if (this.scrollCount < 0) this.scrollCount = 0;
                    if (this.scrollCount >= sectionElements.length) this.scrollCount = sectionElements.length - 1;

                    // 使用 scrollIntoView 确保滚动到该 section
                    const targetSection = sectionElements[this.scrollCount];
                    if (targetSection) {
                    targetSection.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center', // 使目标元素在视口的垂直方向居中
                        inline: 'center' // 水平方向居中（可选）
                    });
                    }




                    const scrollHeight = scrollContainer.scrollHeight;
                    const containerHeight = scrollContainer.clientHeight;
                    // 检查滚动位置并设置 isScrolled
                    // 滚动状态判断
                    const scrollTop = scrollContainer.scrollTop;
                    if (scrollTop === 0) {
                        this.isScrolled = false;
                    } else if (scrollTop + containerHeight >= scrollHeight) {
                        this.isScrolled = true;
                    } else {
                        this.isScrolled = true;
                    }
                    let height;
                        height = window.innerHeight;
                        
                        scrollContainer.scrollBy({

                            top: event.deltaY > 0 ? height : -height,
                            behavior: 'smooth'
                        });


                    this.scrollCount += 1; // 增加滚动计数
                    // 等待 DOM 更新后再检查可见的 sections
                  

                        // 重新添加 fadeIn 类到当前可见的 .content
                        //this.checkVisibleSections(); // 检查可见的 sections

                       




                    event.preventDefault();
                }
            },
            debounce(func, wait) {
                let timeout;
                return function(...args) {
                    const context = this;
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(context, args), wait);
                };
            },
        }
    }
</script>
<style scoped>
.imgend{
    display: flex;
    justify-content: center; /* 水平居中 */
   margin-top: 9vh;
   margin-bottom: 25vh;
   
}
.imgend img{
    width: 60vw;
}
.safenote{
    display: flex;
    flex-direction: column;      /* 子元素垂直排列 */
    justify-content: center;     /* 垂直方向居中 */
    align-items: center;         /* 水平方向居中 */
    gap: 1vh;
    margin-top: 8vh;
}
.safenote .title{
    width: 60vw;
    font-weight: bold;
        font-size: 1.5rem;
       
}
.safenote ul{
    width: 60vw;
    font-size: 1rem;
    line-height: 2;
    
}



.TIPS{
    display: flex;
    flex-direction: column;      /* 子元素垂直排列 */
    justify-content: center;     /* 垂直方向居中 */
    align-items: center;         /* 水平方向居中 */
    margin-top: 5vh;
    height: 40vh;
    gap: 3vh;
}
.TIPS .title{
        width: 60vw;
        font-weight: bold;
        font-size: 1.5rem;
      
}
.TIPS .content{
    width: 60vw;
   
    font-size:1rem;
    line-height: 2;
}
.TIPS .Indicate{
    width: 60vw;
    line-height: 2;
 
}

.P01Instructions{
    display: flex;
    flex-direction: column;      /* 子元素垂直排列 */
    justify-content: center;     /* 垂直方向居中 */
    align-items: center;         /* 水平方向居中 */
    height: 100vh;
    margin-top: 8vh;
}
.P01Instructions .title{
    width: 60vw;
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;         /* 文字水平居中 */
    margin-bottom: 5vh;

}
.P01Instructions .videos video{
    width: 60vw;
}

.P01Instructions .content{
    color: #665b5b;
    font-size: 0.8rem;
    width: 60vw;
}



/* 台式大电脑 (1200px 及以上) 样式 */
@media (min-width: 1600px) {
    .xiahuaxian{
        margin-top: 54vh!important;
    }
}
/* 第一张图片开始 */
.imgone img{
    width: 100%;
        height: auto;
        /* margin-bottom: 9vh; */
}
.imgoneru{
    width: 100%;
        height: auto;
        /* margin-bottom: 9vh; */
}
/* 第一张图片结束 */
    .fadeIn {
        animation: fade-in ease 2s !important; /* 添加 !important 提高优先级 */
        animation-fill-mode: forwards;
    }
    @keyframes fade-in {
        from {
            opacity: 0;
            transform: translateY(100px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .red{
        background-color: red;
    }
/*整体布局开始*/
.boddy {
height: 100vh;
background-color: white;


overflow-y: auto; /* 允许垂直滑动 */
}
/* 隐藏滚动条，适用于Webkit浏览器（如Chrome、Safari） */
.boddy::-webkit-scrollbar {
display: none;
}

/* 隐藏滚动条，适用于Firefox */
.boddy {
scrollbar-width: none; /* Firefox */
}

/* 隐藏滚动条，适用于Internet Explorer 和 Edge */
.boddy {
-ms-overflow-style: none; /* Internet Explorer 和 Edge */
}

/*整体布局结束*/
/*内容部分开始*/
.section{
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
/*内容部分结束*/
.titlehed{
    display: none;

}
/*手机端样式开始*/
@media screen and (max-width: 768px) {

    .titlehed{
        display: block!important;
        height: 10rem!important;
    }

}
/*手机端样式结束*/
</style>
